import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

export const getUser = (state: RootState) => state.user;

const hasDispatchRole = (user: RootState["user"]) => user.isDispatch || Boolean((user as any).roles?.dispatch);
const hasManagerAccess = (user: RootState["user"]) => user.isManager || Boolean((user as any).roles?.manager);
const technicianRoleAliases = ["technician", "building maintenance technician", "building_maintenance_technician"];

const hasTechnicianRole = (user: RootState["user"]) => {
  const roleName = String((user as any).role || "").toLowerCase();
  const hasRole =
    Boolean((user as any).roles?.technician) ||
    Boolean((user as any).roles?.["building maintenance technician"]) ||
    Boolean((user as any).roles?.building_maintenance_technician) ||
    Boolean((user as any).roles?.buildingMaintenanceTechnician) ||
    technicianRoleAliases.includes(roleName);

  return hasRole && !hasManagerAccess(user) && !hasDispatchRole(user);
};

export const getLoggedIn = createSelector([getUser], (user) => user.loggedIn);
export const getLoginDate = createSelector([getUser], (user) => user.loginDate);
export const getUserData = createSelector([getUser], (user) => ({
  role: user.role || resolvedRole(user),
  id: user.id,
  firstName: user.firstName,
  lastName: user.lastName,
  email: user.email,
  clientId: user.clientId,
  vendorId: user.vendorId,
  photo: user.photo,
  profilePicture: user.profilePicture,
  maximoTimezone: user.maximoTimezone,
  loggedIn: user.loggedIn,
  phoneNumber: user.phoneNumber,
  isManager: hasManagerAccess(user),
  isVendor: user.vendorId !== "",
  isClient: user.clientId !== "",
  isDispatch: hasDispatchRole(user),
  isTechnician: hasTechnicianRole(user),
}));

function resolvedRole(user: RootState["user"]) {
  if (hasManagerAccess(user)) {
    return "manager";
  }

  if (hasDispatchRole(user)) {
    return "dispatch";
  }

  if (hasTechnicianRole(user)) {
    return "technician";
  }

  return "";
}
